// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textBox:hover {
  cursor: pointer;
}

.textBox:hover .iconBox {
  visibility: visible;
}

.iconBox {
  visibility: hidden;
}

.credit_box {
  border: 1px solid #e4e4e4;
  height: 3.25rem;
  border-radius: 8px;
}

.chat_heading,
.credit_box_heading {
  color: #18181b;
  font-size: 0.875rem;
  font-weight: 600;
}

.credit_box_number {
  font-size: 24px;
  font-weight: 300;
  color: #a9acb4;
}

.credit_box_number_active {
  color: #0066cc;
  font-weight: 600;
}

/* history */
.chat_history_container {
  /* height: calc(100vh - 201px); */
  height: 100%;
  border: 1px solid rgba(228, 228, 228, 1);
  border-radius: 4px;
  overflow-y: auto;
  scrollbar-width: thin;
}

.chat_history_container .playground-container {
  border-radius: 4px;
  padding: 8px;
}

.chat_history_container .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.chat_history_container h5 {
  color: #18181b;
  font-size: 1rem;
  font-weight: 600;
}

.new_chat_btn {
  box-shadow: rgba(0, 0, 0, 0.3) 0px 0.5px 2.5px 0px;
  border-color: none !important;
  border: 1px solid #ffffff !important;
  font-size: 0.75rem;
}

.chat_history_container .history-list {
  /* max-height: 500px; */
  overflow-y: auto;
}

.chat_history_container .history-list .list-group-item {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  cursor: pointer;
  padding: 8px;
  border: none;
  margin-bottom: 2px;
}

.chat_history_container .history-list .list-group-item:hover {
  background: #e6f2ff;
  border-radius: 5px;
}

.chat_history_container .active-item {
  background-color: #e6f2ff !important;
  color: #0066cc !important;
  border-radius: 5px;
  border-right: 5px solid #0066cc !important;
  font-weight: 500;
}

/* new chat message UI */
.chat-message {
  margin: 12px 0;
  align-items: flex-end;
  position: relative;
}

.functionBox .circle-icon {
  width: 36px;
  height: 36px;
  background-color: #ebebeb;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.functionBox .chat-bubble {
  max-width: 70%;
  padding: 10px 14px;
  border-radius: 16px;
  position: relative;
  word-wrap: break-word;
  white-space: pre-wrap;
  transition: all 0.2s ease-in-out;
}

.functionBox .user-bubble {
  background-color: #005eef;
  color: #fff;
  border-bottom-right-radius: 4px;
}

.functionBox .ai-bubble {
  background-color: #f1f1f1;
  color: #333;
  border-bottom-left-radius: 4px;
}

/* Hover icons (hidden by default) */
.functionBox .hover-icons {
  display: none;
  position: absolute;
  bottom: -10px;
  font-size: 14px;
  color: gray;
  gap: 6px;
}

.ai-bubble:hover .hover-icons {
  display: flex;
  left: 0;
  cursor: pointer;
}

.user-bubble:hover .hover-icons {
  display: flex;
  right: 0;
  cursor: pointer;
}

.listItemHover .trashIcon {
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease-in-out;
}

.trashIcon {
  right: 0;
}

.listItemHover:hover .trashIcon {
  opacity: 1;
  pointer-events: auto;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/PromptPlayground.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,iCAAiC;EACjC,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kDAAkD;EAClD,6BAA6B;EAC7B,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,8BAA8B;AAChC;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB","sourcesContent":[".textBox:hover {\n  cursor: pointer;\n}\n\n.textBox:hover .iconBox {\n  visibility: visible;\n}\n\n.iconBox {\n  visibility: hidden;\n}\n\n.credit_box {\n  border: 1px solid #e4e4e4;\n  height: 3.25rem;\n  border-radius: 8px;\n}\n\n.chat_heading,\n.credit_box_heading {\n  color: #18181b;\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n.credit_box_number {\n  font-size: 24px;\n  font-weight: 300;\n  color: #a9acb4;\n}\n\n.credit_box_number_active {\n  color: #0066cc;\n  font-weight: 600;\n}\n\n/* history */\n.chat_history_container {\n  /* height: calc(100vh - 201px); */\n  height: 100%;\n  border: 1px solid rgba(228, 228, 228, 1);\n  border-radius: 4px;\n  overflow-y: auto;\n  scrollbar-width: thin;\n}\n\n.chat_history_container .playground-container {\n  border-radius: 4px;\n  padding: 8px;\n}\n\n.chat_history_container .header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.chat_history_container h5 {\n  color: #18181b;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.new_chat_btn {\n  box-shadow: rgba(0, 0, 0, 0.3) 0px 0.5px 2.5px 0px;\n  border-color: none !important;\n  border: 1px solid #ffffff !important;\n  font-size: 0.75rem;\n}\n\n.chat_history_container .history-list {\n  /* max-height: 500px; */\n  overflow-y: auto;\n}\n\n.chat_history_container .history-list .list-group-item {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  cursor: pointer;\n  padding: 8px;\n  border: none;\n  margin-bottom: 2px;\n}\n\n.chat_history_container .history-list .list-group-item:hover {\n  background: #e6f2ff;\n  border-radius: 5px;\n}\n\n.chat_history_container .active-item {\n  background-color: #e6f2ff !important;\n  color: #0066cc !important;\n  border-radius: 5px;\n  border-right: 5px solid #0066cc !important;\n  font-weight: 500;\n}\n\n/* new chat message UI */\n.chat-message {\n  margin: 12px 0;\n  align-items: flex-end;\n  position: relative;\n}\n\n.functionBox .circle-icon {\n  width: 36px;\n  height: 36px;\n  background-color: #ebebeb;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n}\n\n.functionBox .chat-bubble {\n  max-width: 70%;\n  padding: 10px 14px;\n  border-radius: 16px;\n  position: relative;\n  word-wrap: break-word;\n  white-space: pre-wrap;\n  transition: all 0.2s ease-in-out;\n}\n\n.functionBox .user-bubble {\n  background-color: #005eef;\n  color: #fff;\n  border-bottom-right-radius: 4px;\n}\n\n.functionBox .ai-bubble {\n  background-color: #f1f1f1;\n  color: #333;\n  border-bottom-left-radius: 4px;\n}\n\n/* Hover icons (hidden by default) */\n.functionBox .hover-icons {\n  display: none;\n  position: absolute;\n  bottom: -10px;\n  font-size: 14px;\n  color: gray;\n  gap: 6px;\n}\n\n.ai-bubble:hover .hover-icons {\n  display: flex;\n  left: 0;\n  cursor: pointer;\n}\n\n.user-bubble:hover .hover-icons {\n  display: flex;\n  right: 0;\n  cursor: pointer;\n}\n\n.listItemHover .trashIcon {\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s ease-in-out;\n}\n\n.trashIcon {\n  right: 0;\n}\n\n.listItemHover:hover .trashIcon {\n  opacity: 1;\n  pointer-events: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
